// 查企业接口
import request from '@/utils/request'

// 查询企业资质证书信息
export const getCertInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/certificateRecord/getCertificateInfoVoList',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业溯源信息
export const getTraceInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyCertSource/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询所有注册企业信息 (网厅)
export const pageCompany = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/pageCompanyInfo',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页高级查询所有注册企业信息 (网厅)
export const pageCompanyAdvance = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/pageCompanyInfoHigh',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询注册企业信息详细
export const getCompanyInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/getCompanyInfo',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询企业下工程项目信息表
export const pageProjectInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectRecord/companyPageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询企业下的业绩技术指标表
export const pageAchievementInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectPerformanceIndicator/pageTabCompany',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询当前企业下的人员证书信息
export const pagePersonCertificateInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/companyPageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询企业信用行为
export const pageCreditBehavior = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyBehavior/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询企业行政处罚信息表
export const getCompanyPunis = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyPunis/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业信用行为详情
export const getCompanyBehaviorDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyBehavior/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业风险提醒详情（不消耗会员权益次数，且id是加密）
export const getCompanyWarningDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyBehavior/getInfo',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业行政处罚信息详情
export const getCompanyPunisDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyPunis/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业变更记录表
export const getCompanyChangeRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyChange/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业画像
export const getCompanyPortrayal = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/companyPortrayal',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业-证件数量分析
export const getCompanyCertCountAnalyse = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/companyAnalyse',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业-企业人员结构分析
export const getCompanyPersonAnalyse = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/companyPersonAnalyse',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业-证书类型分析
export const getCompanyCertTypeAnalyse = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/companyCertTypeAnalyse',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业-资质等级对比分析
export const getCompanyCertGradeAnalyse = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/iCompanyInfo/companyCertGradeAnalyse',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业-企业行为记录分析
export const getCompanyBehaviorAnalyse = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyBehavior/companyBehaviorAnalyse',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业-企业变动分析
export const getCompanyChangeAnalyse = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyChange/companyChangeAnalyse',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-企业报告导出
export function exportCompnayReport() {
	return process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/companyChange/exportCompanyReport'
}
